<template lang="pug">
	
	.youth
		youth-intro
		youth-presentation

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../../utils/scroller.js'
	import Ticker from '../../utils/ticker.js'
	import * as PIXI from 'pixi.js'

	import YouthIntro from './_components/youth-intro.vue'
	import YouthPresentation from './_components/youth-presentation.vue'

	import Scrollable from '~abstracts/scrollable'

  	@Component({
		name: 'Youth',
		components: { YouthIntro,YouthPresentation  }
	})

	class Youth extends Scrollable {


		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
		
		}

		initIntervals () {

		}

		_resize () {
			super._resize()

			this.initIntervals()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Youth

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.youth
		width 100%
		background $COLOR_BLUE
		position relative

	
</style>


// WEBPACK FOOTER //
// youth.vue?68abdbd2